module.exports = __webpack_public_path__ + "static/media/test23-2.445a77fb.png";